import React from 'react'

// displays first letter of label in a circle
type Props = { label?: string, size?: 'md' | 'lg' | 'xl', icon?: React.ReactElement }
const Avatar: React.FC<Props> = ({ label, icon, size = 'md' }) => {
  let sizeClasses = 'w-10 h-10 min-h-10 min-w-10'
  if(size === 'lg') {
    sizeClasses = 'w-14 h-14 min-h-14 min-w-14'
  } else if(size === 'xl') {
    sizeClasses = 'w-24 h-24 min-h-24 min-w-24'
  }
  return (
    <div className={`${sizeClasses} rounded-full flex items-center justify-center bg-deep-green text-white`}>
      {icon}
      {label && label.length > 0 ? label[0].toUpperCase() : ''}
    </div>
  )
}

export default Avatar
